import React from 'react';
export const DrumKitContext = React.createContext(undefined);
export const useDrumKitContext = () => {
    const context = React.useContext(DrumKitContext);
    if (context == null) {
        throw new Error('DrumKitContext not found');
    }
    return context;
};
//# sourceMappingURL=DrumKitContext.js.map